// The file structure: id: "text"
// for additional description there will be // over the id: "text"
// Strings with ${variable} in are generated, ${} meand variable require for proper message display

const ERRORS = {
  // CLASSROOMS SAGA
  handleFetchClassrooms: "Something went wrong while fetching classrooms.",
  handleAssignClassroomTribyteTest: "This test can only be assigned once",
  fetchClasses: "Something went wrong while fetching classes.",
  fetchClassroom: "Something went wrong while fetching class.",
  handleFetchClassroom: "Something went wrong while fetching classroom.",
  handleFetchMoreClassrooms: "Something went wrong while fetching more classrooms.",
  handleFetchClassroomSummary: "Something went wrong while fetching the classroom summary stats.",
  handleSearchClasses: "Something went wrong while searching classrooms.",
  handleFetchClassSubjects: "Something went wrong while fetching classroom subjects.",
  fetchClassUnits: "Something went wrong while fetching classroom units.",
  handleAssignLessonToClassCalendar:
    "Something went wrong while updating class calendar lessons. Please try again later.",
  handleAssignClassroomTest:
    "Something went wrong while assigning a new test from calendar. Please try again later.",
  handleAssignSessionToClassroomSaga:
    "Something went wrong while assigning a new session from calendar.",
  handleFetchOneClassLessonList: "Something went wrong while fetching class lessons.",
  handleFetchLessonPreviewClassDetail: "Something went wrong while fetching lesson details.",
  handleUnAssignLessonFromClass: "Something went wrong while unassigning lesson from class.",
  handleUnAssignTestFromClass: "Something went wrong while unassigning test from class.",
  handleRescheduleClassLessons:
    "Something went wrong while trying to reschedule this lesson. Please try again later.",
  handleRescheduleClassTests:
    "Something went wrong while trying to reschedule this test. Please try again later.",
  handleFetchClassroomTestsSaga: "Something went wrong while fetching for class tests.",
  handleAddStudentToClass: "Something went wrong while adding student to class.",
  handleRemoveStudentFromClass: "Something went wrong while removing students from class.",
  handleUpdateClass: "Something went wrong while trying to update this class.",
  handleUpdateClassArchived: "Something went wrong while trying to archive this classroom.",
  handleRemoveUserFromClass: "Something went wrong while removing user from class.",
  handleSelectAllClassLessons: "Something went wrong while fetching Classroom's Lessons.",
  handleFetchClassDetails: "Something went wrong while fetching class details.",
  handleUpdateClassroomSessionSaga:
    "There was a problem while updating this classroom session. Please try again later.",
  handleAssignTestToClass:
    "Something went wrong while assigning a classroom test. Please try again later.",
  handleDeleteClassSession: "Couldn't delete this classroom session.",
  handleQueryClassroom: "Something went wrong while fetching classrooms with query string.",
  handleFetchSimpClassrooms: "Something went wrong while fetching classrooms list.",
  handleAssignWorksheetToClass:
    "Something went wrong while updating class calendar worksheets. Please try again later.",
  handleFetchClassroomWorksheetsList: "Something went wrong while fetching worksheets list.",
  handleFetchWorksheetPreviewClassDetail:
    "Something went wrong while fetching class worksheet details.",
  handleUnassignWorksheetFromClassroomSaga:
    "Something went wrong while unassigning worksheet from classroom.",
  handleRescheduleClassroomWorksheetsSaga:
    "Something went wrong while trying to reschedule this worksheet. Please try again later.",
  handleSelectAllClassWorksheets: "Something went wrong while fetching Classroom's Worksheets.",
  handleFetchClassReportPDF: "Couldn't fetch or generate class report PDF.",
  handleAssignLessonsToClassSaga: "Something went wrong while assigning lesson to class.",
  handleDeleteMultipleItemsFromClassSaga: "Something went wrong while deleting multiple items.",
  handleFetchClassCalendarDataSaga: "Something went wrong while fetching classroom calendar data.",
  handleOpenSelectedItemDetailsClassroomSaga: "Something went wrong while opening details.",
  // COURSES SAGA
  handleGetCourses: `Something went wrong while fetching for courses. Please try again later.`,
  // COURSE TEMPLATES SAGA
  fetchCourseTemplate: "Something went wrong while fetching course template.",
  handleGetCourseTemplates:
    "Something went wrong while fetching for course templates. Please try again later.",
  handleFetchMoreCourseTemplates: "Something went wrong while fetching more courseTemplate.",
  handleFetchCourseTemplateSessions: "Unable to create session schedule. Please try again later.",
  handleApplyCourseTemplates:
    "Something went wrong while fetching for course templates. Please try again later.",
  handleQueryCourseTemplate: "Something went wrong while fetching courseTemple with query string.",
  handleCreateCourseTemplate: "Unable to create new course template. Please try again later.",
  handleUpdateCourseTemplate: "Unable to update course template. Please try again later.",
  fetchUnassignedLessons: "Something went wrong while fetching lessons.",
  handleClearStudentFilters:
    "Something went wrong while fetching course templates with query string and cleaning filters.",
  handleApplyTemplateToStudent: "Error occurred applying template to student.",
  handleFetchCourseTemplates: "Something went wrong while fetching course template.",
  handleApplyTemplateToClass: "Error occurred applying template to class.",
  handleFetchSelectedCourseTemplateSaga:
    "Something went wrong while fetching selected course template.",
  // GLOBAL SAGA
  handleSendWelcomeEmail: "Something went wrong while sending email.",
  handleFetchAllTestsTemplates: "Something went wrong while fetching Tests templates.",
  handleFetchLessonsTemplates: "Something went wrong while fetching Lessons templates.",
  // INSTRUCTORS SAGA
  fetchInstructors: "Something went wrong while fetching Instructors.",
  handleFetchInstructor: "Something went wrong while fetching Instructor.",
  fetchInstructorSummary: "Something went wrong while fetching Instructor's summary.",
  createInstructor: "Something went wrong while creating Instructor.",
  createClassroom: "Something went wrong while creating Classroom",
  deactivateInstructor: "Something went wrong while deactivating Instructor.",
  updateInstructor: "Something went wrong while updating Instructor.",
  updateInstructorAddress: "Something went wrong while updating Instructor's address.",
  addInstructorToLocation: "Something went wrong while adding Instructor to the location.",
  removeInstructorFromLocation: "Something went wrong while removing Instructor from location.",
  fetchInstructorStudents: "Something went wrong while fetching Instructor's students.",
  handleFetchInstructorStudents: "Something went wrong while fetching Instructor's Students.",
  handleFetchInstructors: "Something went wrong while fetching instructors.",
  handleFetchInstructor: "Something went wrong while fetching Instructor.",
  handleFetchMoreInstructors: "Something went wrong while fetching more instructors.",
  handleFetchInstructorSummary:
    "Couldn't find this instructor's details. Please check again at a later time.",
  handleFetchCurrentInstructorSummary:
    "Couldn't find this instructor's details. Please check again at a later time.",
  handleCreateInstructorEmailExists:
    "A user with this email address already exists. Please contact your account administrator if you need access to this user's account.",
  handleCreateInstructorNoEmail:
    "An email is required to create an instructor. Please enter an Email.",
  handleCreateInstructor:
    "Something went wrong while creating instructor. Please make sure you have entered all required field.",
  handleDeactivateInstructorNoPermissions: "You do not have permission to disable this instructor.",
  handleDeactivateInstructor: "Something went wrong while deactivating instructor.",
  handleArchiveInstructor:
    "Something went wrong while archiving this instructor. Please try again later.",
  handleArchiveStudent:
    "Something went wrong while archiving this instructor. Please try again later.",
  handleUpdateInstructorEmailsExists:
    "A user with this email address already exists. Please contact your account administrator if you need access to this user's account.",
  handleUpdateInstructor: "Something went wrong while updating instructor account info.",
  handleUpdateInstructorAddress: "Something went wrong while updating instructor contact info.",
  handleAddInstructorToLocation: "Something went wrong while adding instructor to Location.",
  handleRemoveInstructorFromLocation:
    "Something went wrong while removing instructor from location.",
  handleQueryInstructors: "Something went wrong while fetching instructors with filters.",
  handleUpdateShowWelcomeVideo:
    "️Something went wrong while disabling the welcome video. Try again on your next login.",
  grantInstructorFullAccessToOrganization:
    "Something went wrong while granting full access to organization.",
  revokeInstructorFullAccessToOrganization:
    "Something went wrong while revoking full access to organization.",
  handleUpdateInstructorManagement: "Something went wrong while updating instructor.",
  handleFetchSimpInstructors: "Something went wrong while fetching Instructors.",
  // LOCATIONS SAGA
  handleFetchLocation: "Something went wrong while fetching Locations.",
  fetchAllLocations: "Something went wrong while fetching all Locations.",
  handleFetchLocation: "Something went wrong while fetching Location.",
  handleFetchCurrentLocation: "Something went wrong while fetching current Locations.",
  handleFetchActiveLocationSummary: "Something went wrong while fetching Location's details.",
  handleFetchMoreLocations: "Something went wrong while fetching more locations.",
  handleQueryLocations: "Something went wrong while fetching locations with query string.",
  handleFetchSimplifiedLocations: "Something went wrong while fetching Simplified Locations.",
  handleCreateLocation: `Something went wrong while creating a location. Please try again later.`,
  handleCreateBranding: `Something went wrong while creating branding}`,
  handleCreateBrandingLongVersion: `Something went wrong while saving the branding. You can try editing the location's branding in the account tab of that location.`,
  handleUpdateLocationBrandingShort: "Something went wrong while updating branding.",
  handleUpdateLocationBranding: `Something went wrong while applying branding to this location. You can try editing the location's branding in the account tab of that location.`,
  handleUpdateLocationValues: (value: string) => `Error occurred: ${value}.`,
  handleUpdateLocation: `Something went wrong while updating this location. Please try again later.`,
  // STUDENTS SAGA
  fetchStudent:
    "Something went wrong while attempting to activate this student. Please check that you have the correct key code or try again later.",
  handleFetchStudents: "Something went wrong while fetching students.",
  handleFetchStudent: "Something went wrong while fetching student.",
  handleFetchMoreStudents: "Something went wrong while fetching more students.",
  handleQueryStudents: "Something went wrong while fetching students with query string.",
  createNewStudent: `Something went wrong while creating a student. Please try again later.`,
  createNewStudentEmailExists: `A student with this email address already exists. Please contact your account administrator if you need access to this student's account.`,
  createNewStudentAssigningInstructor:
    "Something went wrong while assigning an instructor to the student. Please try again later.",
  createNewStudentCourseContext: `Unable to update course context.`,
  searchStudents: "Something went wrong while searching for students.",
  watchForDeleteStudent: "Something went wrong while deleting a student.",
  handleUpdateStudentReportSaga:
    "Something went wrong while updating this student's report. Please try again later.",
  handleSendReportSaga: `Something went wrong while updating this student's report. Please try again later.`,
  fetchReportPreviewSaga: `Something went wrong while updating this student's report. Please try again later.`,
  handleUpdateStudent: `Something went wrong while updating this student. Please try again later.`,
  handleUpdateStudentEmailExists: `A student with this email address already exists.`,
  handleUpdateStudentAddress: `Something went wrong while updating this student's address. Please try again later.`,
  handleAddStudentToLocation: `Unable to update locations field.`,
  handleRemoveStudentFromLocation: `Unable to update locations field.`,
  handleFetchStudentReportPDF: `Couldn't fetch or generate class report PDF.`,
  handleFetchStudentSummary:
    "Couldn't find details for this student. Please check again at a later time.",
  handleFetchUnitsSaga: "Error occurred while  fetching units.",
  fetchStudentTestSections: `Something went wrong while retrieving sections for this test.`,
  fetchStudentTestSectionsRetrieve: `Couldn't retrieve one or more sections with problems for this test. Those sections will not be shown. Please try again later.`,
  fetchAllTests: "Error occurred while fetching tests.",
  handleFetchStudentTestsSaga: `Unable to get data student test data. Please try again later.`,
  handleFetchAllStudentTests: `Unable to get data all student tests data. Please try again later.`,
  handleAssignStudentTest:
    "Something went wrong while assigning a new test from calendar. Please try again later.",
  handleDeleteStudentTest: "Something went wrong while deleting Student's test.",
  handleMarkAllFlagsReviewed: "Something went wrong while searching for flagged problems.",
  handleUpdateTestStatus: (status: string) =>
    `Something went wrong while updating this test to ${status}. Please try opening and resubmitting this test later.`,
  handleUpdateTestAssignmentDate: `Something went wrong while rescheduling Assignments Date. Please try again later.`,
  handleUpdateTestDueDate: `Something went wrong while rescheduling Due Date. Please try again later.`,
  handleUpdateTestNotify: `Something went wrong while rescheduling Notify. Please try again later.`,
  handleUpdateTestPace: `Something went wrong while rescheduling Pace. Please try again later.`,
  handleUpdateTestSections: `Something went wrong while updating this test sections. Please try changing test settings later.`,
  handleUpdateTestFlagStatus: `Something went wrong while adding a flag to this problem.`,
  handleFetchActiveTestScores: "Something went wrong while fetching scores.",
  handleResetStudentTests:
    "Something went wrong while resetting this test. At least one of the tests fail to reset.",
  handleRescoreTestAnswers: `This test couldn't be re-scored right now. Please try again later.`,
  handleUpdateStudentTestSectionStatus: `Cannot update the status of active test section.`,
  handleUpdateStudentTestSectionStatusApi: `Cannot update the status of active test section.`,
  handleUpdateStudentTargetScore: "The target score value must be between 400 and 2000.",
  handleUpdateCourseContext: "Unable to update course context.",
  handleUpdateStudentFlags:
    "Something went wrong updating the student account settings. Please try again later.",
  handleFetchStudentSessions:
    "Something went wrong fetching this student's sessions. Please try again later.",
  handleUpdateStudentSession: "Something went wrong updating this session. Please try again later.",
  handleFetchLesson: "Something went wrong while fetching Lesson.",
  handleFetchStudentLessonList: `Unable to get student lesson data. Please try again later.`,
  handleAssignLesson:
    "Something went wrong while updating student calendar lessons. Please try again later.",
  handleResetLessons: "Something went wrong while resetting lessons.",
  handleUpdateStudentActivationActivationError:
    "Can't activate student. Please check that you have the correct key code or try again later.",
  handleUpdateStudentActivation:
    "Something went wrong while attempting to activate this student. Please check that you have the correct key code or try again later.",
  handleUnAssignLesson: "Something went wrong while unassigning lessons from student.",
  handleRescheduleStudentLessons:
    "Something went wrong while trying to reschedule this lesson. Please try again later.",
  handleExcuseStudentLateness: "Something went wrong while excusing lesson lateness.",
  handleFlagStudentLessonProblem: `Something went wrong while marking all flags for a lesson as reviewed. Please try again later.`,
  handleAnswerStudentLessonProblem:
    "Something went wrong while submitting answers for lessons. Please try again later.",
  handleSubmitBulkLessonAnswers:
    "Something went wrong while submitting answers for this lesson. Please try again later.",
  handleFetchSubjects: "Error occurred while fetching Subjects.",
  handleUpdateLessonStatus:
    "Something went wrong while updating this lesson's status. Try again later.",
  handleCompleteLessonSection: "Error occurred while completing lesson section.",
  handleSubmitLessonProblemsBulkError: "Bulk Answers failed!",
  handleSubmitLessonProblems: "Error occurred while submitting lesson problems.",
  handleFetchLessonPreviewDetail: "Error occurred while fetching lesson details.",
  handleFetchLessonProblems: "Something went wrong while fetching lesson problems",
  handleMarkAllLessonFlagsReviewed: "Something went wrong while marking all lesson flags reviewed.",
  handleDeleteStudentSessions: "Something went wrong while deleting student session(s).",
  handleUnAssigningInstructorFromStudent:
    "Something went wrong while unassigning an instructor from the student. Please try again later.",
  handleAssignInstructorToStudent:
    "Something went wrong while assigning an instructor to the student. Please try again later.",
  handleGetStudentCalendarLessons: `Something went wrong while fetching the student's calendar lessons.`,
  handleUnEnrollStudentFromCourse:
    "Something went wrong while unassigning a course from the student. Please try again later.",
  handleFetchWorksheet: "Something went wrong while fetching worksheet.",
  handleFetchStudentWorksheetList: `Unable to get data student worksheet data. Please try again later.`,
  handleAssignWorksheet:
    "Something went wrong while updating student calendar worksheets. Please try again later.",
  handleResetWorksheets: "Something went wrong while resetting worksheet(s).",
  handleUnAssignWorksheet: "Something went wrong while unassigning worksheets from student.",
  handleRescheduleStudentWorksheets:
    "Something went wrong while trying to reschedule this worksheet. Please try again later.",
  handleUpdateWorksheetStatus:
    "Something went wrong while updating this worksheet's status. Try again later.",
  handleSubmitWorksheetProblemsBulkError: "Bulk worksheet's Answers failed.",
  handleSubmitWorksheetProblems: "Something went wrong while submitting worksheet's problems.",
  handleFetchWorksheetPreviewDetail: "Something went wrong while fetching worksheet's details.",
  handleFetchWorksheetDetails: "Something went wrong while fetching worksheet.",
  handleMarkAllWorksheetFlagsReviewed: `Something went wrong while marking all worksheet flags reviewed.`,
  handleUpdateStudentWorksheetProblemFlagStatus: `Something went wrong while marking all flags for a worksheet as reviewed. Please try again later.`,
  handleAnswerStudentWorksheetProblem:
    "Something went wrong while submitting answers for worksheets. Please try again later.",
  handleSubmitBulkWorksheetAnswers:
    "Something went wrong while submitting answers for worksheet. Please try again later.",
  handleExcuseStudentWorksheetLateness:
    "Something went wrong while excusing student worksheet lateness.",
  handleGetStudentCalendarWorksheets: `Something went wrong while fetching the student's calendar worksheets.`,
  handleFetchCategories: `Something went wrong while fetching the worksheet categories.`,
  handleAssignLessonsToStudentSaga: "Something went wrong while assigning Lesson to Student.",
  handleCreateStudentSession:
    "Something went wrong while creating a session. Please try again later.",
  handleDeleteMultipleItemsFromStudentSaga: "Something went wrong while deleting multiple items.",
  handleOpenSelectedItemDetailsSaga: "Something went wrong while fetching details.",
  handleOpenSelectedItemDetailsSagaWorksheet:
    "Something went wrong while fetching worksheet's details.",
  handleRescheduleStudentTest: `Something went wrong while rescheduling test.`,
  // USER SAGA
  handleFetchCurrentUser: "Something went wrong while fetching user data.",
  handleUpdateInstructorAvatar:
    "Something went wrong while updating your avatar. Please try again later.",
  handleChangePassword: `Something went wrong while changing your password. Please try again later.`,
  handleChangePasswordInvalidToken: `The password reset token appears to be invalid, expired, or used.`,
  handleChangePasswordValidationError: `Something went wrong while validating your new password. Your token or new password might be invalid.`,
  handleResetPassword: `Something went wrong while sending a reset password email. Please try again later.`,
  handleResetPasswordNoEmail: `Something went wrong with this request. Please make sure your email is included and typed correctly.`,
  handleResetPasswordInvalidEmail: `This email address cannot be found. Please try again with a valid email.`,
  impersonateSaga: "Something went wrong while impersonating.",
  handleImpersonateInvalidLocation: (type: string) =>
    `Could not find the correct location for this ${type}.`,
  handleImpersonate: "Something went wrong while Impersonating.",
  handleImpersonateByType: (type: string) =>
    `Something went wrong while Impersonating ${type}. Please try again later.`,
  handleUpdateLastVersionSeen: "Something went wrong while updating last version seen.",
  handleUpdateStudentTest: "Something went wrong while updating test",
  handleRescheduleGroupStudentCalendarSaga:
    "Something went wrong while rescheduling selected assignments.",
  handleUpdateStudentBaselineScoresSaga:
    "Something went wrong while updating Student's baseline scores.",
  handleCreateStudentRealTestSaga: "Something went wrong while creating student's test.",
  handleUpdateStudentRealTestSaga: "Something went wrong while updating student's test.",
  handleUpdateRealStudentTest: "Something went wrong while updating student Real Test elements.",
  handleUpdateClassroomTestSections: "Something went wrong while updating classroom test sections.",
  handleUpdateClassroomTest: "Something went wrong while updating classroom test.",
  handleDeleteClassroomSaga: "Something went wrong while removing classroom.",
  handleFetchStudentLessonsSaga: "Something went wrong while fetching student's lesson.",
  handleExcuseStudentLessonLatenessSaga:
    "Something went wrong while changing lesson lateness status.",
  handleMarkStudentLessonsFlagsReviewedSaga:
    "Something went wrong while lesson(s) flags were marked as reviewed.",
  handleFetchStudentLessonDetailsSaga: "Something went wrong while fetching lesson details",
  handleManageStudentEnrollmentsSagaAdd:
    "Something went wrong while trying to enroll the student in the course. Please try again later.",
  handleManageStudentEnrollmentsSagaRemove:
    "Something went wrong while trying to unenroll the student from this course. Please try again later.",
  handleManageStudentEnrollmentsSagaGeneral:
    "Something went wrong while trying to update the student’s enrollment status. Please try again later.",
  handleFetchStudentWorksheetsSaga: "Something went wrong while fetching student's worksheets.",
  handleDeleteLocation: "User must be assigned to at least one location!",
  handleAddBulkAnswerToStudentTestSaga: "Something went wrong while saving section's answers.",
  handleStudentTestSectionManagementSaga:
    "Something went wrong while updating test or it's section.",
  fetchStudentDetailsNoStudent: (id: string) =>
    `No student with given id, please check provided id: ${id}.`,
  handleOpenLessonDetailsSaga: "Something went wrong while fetching lesson details.",
  handleFetchLessonTemplateDetailsSaga:
    "Something went wrong while fetching Lesson template details.",
  handleFetchWorksheetTemplateDetailsSaga:
    "Something went wrong while fetching Worksheet template details.",
  handleFetchTestTemplateDetailsSaga: "Something went wrong while fetching Test template details.",
  handleFetchLessonsHintsSaga: "Something went wrong while fetching lessons names hints.",
  handleFetchWorksheetsHintsSaga: "Something went wrong while fetching worksheets names hints.",
  handleArchiveStudentsSaga: (isArchive: boolean) =>
    `Something went wrong while ${isArchive ? "" : "un"}archiving students.`,
  handleUpdateStudentAccount: "Something went wrong while updating student.",
  handleExcuseStudentTestLatenessSaga:
    "Something went wrong while processing excuse / unexcuse tests.",
  handleFetchStudentsStatisticsSaga:
    "Something went wrong while fetching students list statistics.",
  handleAddStudentTestProblemFlagSaga:
    "Something went wrong while adding flag to the test's problem.",
  handleFetchStudentScoredTestsSaga: "Something went wrong while fetching scored student's tests.",
  handleUpdateEssayScoreSaga: "Something went wrong while updating Essay Score.",
  handleStartStudentLessonSection: "Something went wrong while starting section.",
  handleOpenWorksheetDetailsSaga: "Something went wrong while fetching Worksheet details data.",
  handleStartStudentWorksheetSaga: "Something went wrong while starting worksheet.",
  handleFetchClassroomWorksheetsSaga: "Something went wrong while fetching Classroom's worksheets.",
  handleUpdateClassroomSagaUpdatingInstructors:
    "Something went wrong while updating classroom's instructors list.",
  handleFetchClassReportPDFNoClassroomTests:
    "This classroom doesn't have tests to generate a report from.",
  handleUpdateStudentErrors: {
    email:
      "This email address is already assigned to another account. To proceed, you must remove the email from the other account, or select a different email address."
  },
  handleFetchClassroomActiveWorksheetSaga:
    "Something went wrong while fetching classroom's worksheet data.",
  handleFetchClassroomActiveTestSaga: "Something went wrong while fetching classroom's test data.",
  handleFetchLocations: "Something went wrong while fetching locations.",
  handleLogin: "Something went wrong while login.",
  logoutSaga: "Something went wrong while logging user out.",
  handleFetchClassroomStudentsSaga:
    "Something went wrong while fetching classroom's students data.",
  handleFetchSimplifiedStudentsSaga:
    "Something went wrong while fetching simplified list of students.",
  handleFetchClassroomCalendarLessonsSaga:
    "Something went wrong while fetching classroom's calendar lessons.",
  handleFetchClassroomCalendarWorksheetsSaga:
    "Something went wrong while fetching classroom's calendar worksheets.",
  handleFetchClassroomCalendarTestsSaga:
    "Something went wrong while fetching classroom's calendar tests.",
  handleAssignClassroomAssignmentToStudentsSaga: (type: string = "assignment") =>
    `Something went wrong while assigning classroom's ${type} to students`,
  handleAddClassroomInstructorSaga: "Something went wrong while adding classroom to instructor.",
  handleFetchClassroomWorksheetsByCategories:
    "Something went wrong while fetching class' worksheets by categories",
  handleFetchStudentWorksheetsByCategories:
    "Something went wrong while fetching student's worksheets by categories",
  handleDeleteCourseTemplates: "Something went wrong while deleting course templates",
  handleFetchTribyteTestSectionSaga: "Something went wrong while fetching url"
};

export default ERRORS;
